import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { login as apiLogin } from "../services/api";
import { styles } from "../styles/Login.styles";
import { FaEnvelope, FaLock, FaFingerprint } from "react-icons/fa";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { setToken, setStampTomador } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [stamp, setStamp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const data = await apiLogin(email, password);
      const token = data?.token;
      if (!token) {
        console.error("[Login] Token não recebido da API");
        throw new Error("Token não recebido");
      }
      setToken(token);
      setStampTomador(stamp || null);
      navigate("/conversas");
    } catch (err) {
      let errorMsg = err.message || "Erro no login";
      
      if (errorMsg.includes("401") || errorMsg.includes("Unauthorized")) {
        errorMsg = "Email ou palavra-passe incorretos";
      } else if (errorMsg.includes("403") || errorMsg.includes("Forbidden")) {
        errorMsg = "Acesso negado. Contacte o administrador.";
      } else if (errorMsg.includes("500")) {
        errorMsg = "Erro no servidor. Tente novamente mais tarde.";
      } else if (errorMsg.includes("Network")) {
        errorMsg = "Erro de conexão. Verifique sua internet.";
      }
      
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleInputFocus = (e) => {
    Object.assign(e.target.style, styles.inputFocus);
  };

  const handleInputBlur = (e) => {
    Object.assign(e.target.style, { borderColor: "#cbd5e1", boxShadow: "none" });
  };

  return (
    <div style={styles.page}>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      <form onSubmit={handleSubmit} style={styles.card}>
        <div style={styles.brandRow}>
          <img
            src="/gemese-chat-logo.png"
            alt="Gemese Chat Logo"
            style={styles.logo}
          />
          <div style={styles.brandText}>
            <span style={styles.brandTitle}>Gemese</span>
            <span style={styles.brandSubtitle}>Chat</span>
          </div>
        </div>
        <h3 style={styles.title}>Bem-vindo de volta</h3>
        <p style={styles.subtitle}>Faça login para acessar a sua conta.</p>
        {error && <div style={styles.error}>{error}</div>}
        <div style={styles.field}>
          <label style={styles.label} htmlFor="email">Email</label>
          <div style={styles.inputWrapper}>
            <span style={styles.inputIcon}>
              <FaEnvelope />
            </span>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.inputWithIcon}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
            />
          </div>
        </div>
        <div style={styles.field}>
          <label style={styles.label} htmlFor="password">Palavra-passe</label>
          <div style={styles.inputWrapper}>
            <span style={styles.inputIcon}>
              <FaLock />
            </span>
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.inputWithIcon}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
            />
            <button
              type="button"
              style={styles.eyeButton}
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Esconder palavra-passe" : "Mostrar palavra-passe"}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        {false && (
        <div style={styles.field}>
          <label style={styles.label} htmlFor="stamp">Stamp</label>
          <div style={styles.inputWrapper}>
            <span style={styles.inputIcon}>
              <FaFingerprint />
            </span>
            <input
              id="stamp"
              value={stamp}
              onChange={(e) => setStamp(e.target.value)}
              style={styles.inputWithIcon}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
            />
          </div>
        </div>
        )}
        <button type="submit" style={{ ...styles.button, ...(loading ? styles.buttonDisabled : {}) }} disabled={loading}>
          {loading && <span style={styles.spinner} />}
          {loading ? "A carregar..." : "Entrar"}
        </button>
      </form>
    </div>
  );
};

export default Login;
